<template>
  <div class="login-wrap" v-wechat-title="$route.meta.title">
    <div style="background:#F8F8FF;z-index:99;height:465px;width:500px;right:200px;top:50%;position:absolute; margin-top:-250px;" >
      <div class="rowstyle" >
        <div style="height:45px;display:flex;background:rgba(120, 128, 128, 0.9)">
          <img style="height:43px;margin-right:10px;color:#409eff;margin-top:1px;margin-left:1px;"  src="@/assets/title.png"/>
          <div style="color:#fff;font-weight: 700;font-size: 20px;line-height:45px;margin-top:2px; ">{{form.title}}</div>
        </div>
        <Tabs value="account" style="width:500px; margin-top:10px;">
          <TabPane :label="form.tabnm1" name="account" icon="md-contacts">
            <div   ref="login"   class="ms-content">
              <div style="  display:flex;justify-content:between; ">
                <el-input v-model="form.username" :placeholder="form.usertip" autofocus=true  @change="dbSelect">
                  <template slot ="prepend" ><i class="iconfont icon-yonghu-xianxing" style="color:#409eff;font-size:20px"></i></template>
                  <template slot ="suffix" ><div style="width:100px;font-weight:600;color:#409eff;font-size:14px;line-height:40px;text-align:right;margin-right:5px; ">{{v_usernm}}</div> </template>
                </el-input>
              </div>
              <div style=" margin-top:20px;display:flex;justify-content:between ">
                <el-input
                    show-password
                    :placeholder="form.pwdtip"
                    autofocus=true
                    ref="pwd"
                    v-model="form.password"
                >
                  <template slot ="prepend" ><i class="iconfont icon-mima1" style="color:#409EFF;font-size:20px;"></i></template>
                </el-input>
              </div>
              <div style=" margin-top:20px;display:flex;justify-content:between ">
                <div style="line-height:35px;background:#F2F6FC;width:60px;"><i class="iconfont icon-zhangtaoguanli1" style="color:#409EFF;font-size:24px;padding-top:13px;"></i></div>
                <el-select v-model="form.corpid"  :placeholder="form.account" clearable  style="width:380px;line-height:40px;" @change="elchange">
                                    <span v-for="item in dbArr" :key='item.key'>
                                        <el-option :label="item.CORPNM" :value="item.IDSEQ" style="width:100%"></el-option>
                                    </span>
                </el-select>
              </div>
              <div style=" margin-top:20px;display:flex;justify-content:between ">
                <el-input
                    :placeholder="form.validtip"
                    ref="holder"
                    @keyup.enter.native="normalLogin"
                    style="width:72%"
                    v-model="validateCompute"
                >
                  <template slot ="prepend" ><i class="iconfont icon-yanzhengyanzhengma" style="color:#409EFF;font-size:20px"></i></template>
                </el-input>
                <span style="margin-left:3px;height:40px">
                                <el-image :src="codeImg"   @click="clickImg" style="height:40px"/>
                                </span>
              </div>
              <el-button  :loading="loading" @click="normalLogin" type="primary"  style=" margin-top:30px;width:440px;height:45px;font-size:16px;background:rgba(128, 128, 128, 0.8)" >
                <i class="iconfont icon-houtai" style="font-size:16px;margin-right:8px"></i>
                <span v-if="!loading">{{form.loginName}}</span>
                <span v-else>{{form.loginName2}}</span>
              </el-button>
              <div style="display:flex;justify-content:space-between;margin-top:15px;margin-bottom:20px; ">
                <el-radio-group v-model="v_lang" size="mini" @change="radioChg">
                  <el-radio-button label="CN"></el-radio-button>
                  <el-radio-button label="EN"></el-radio-button>
                  <el-radio-button label="YN"></el-radio-button>
                </el-radio-group>
                <div>
                  <i class="iconfont icon-mima" style="color:#409eff"></i>
                  <a href="javascript:void(0)" @click="findPassword" style="font-size:10px;"> {{form.forget_pwd}} </a>
                  <Divider type="vertical" class="divcolor"/>
                  <i class="iconfont icon-yonghukaihu" style="color:#409eff"></i>
                  <a href="javascript:void(0)" @click="userRegister" style="font-size:10px;"> {{form.register}} </a>
                </div>
              </div>
            </div>
          </TabPane>
          <!-- <TabPane disabled :label="form.tabnm2" name="msgvalidate" icon="ios-mail-outline">
              <div style=" margin-top:8px ">
                  <el-input @change="msgSelect" :placeholder="form.telno" v-model="msgcode.phoneno" v-enter-number style="width:380px;margin-left:10px;vertical-align:center">
                      <el-select v-model="msgcode.area" slot="prepend" style="width:160px; " :placeholder="form.seltip"  :filterable="filter">
                          <el-option  label="中国大陆 0086" value="0086" ></el-option>
                          <el-option  label="中国香港 0852" value="0852" ></el-option>
                          <el-option  label="中国澳门 0853" value="0853" ></el-option>
                      </el-select>
                  </el-input>
              </div>
              <div style=" margin-top:20px;display:flex;justify-content:between ">
                  <el-input :placeholder="form.teltip" v-model="msgcode.validmsg" v-enter-number style="width:380px;margin-left:65px;">
                      <template slot ="append" >
                          <el-button :disabled="disabled" style="width:140px;"    @click="getAuthCode">{{form.code}}</el-button>
                      </template>
                  </el-input>
              </div>
              <div style=" margin-top:20px;display:flex;justify-content:between ">
                  <div style="line-height:35px;background:#F2F6FC;width:60px;margin-left:65px;"><i class="iconfont icon-zhangtaoguanli1" style="color:#409EFF;font-size:24px;padding-top:13px;"></i></div>
                  <el-select v-model="form.corpid2"  placeholder="请选择账套" clearable  style="width:320px;line-height:40px;" @change="elchange2">
                      <span v-for="item in dbArr2" :key='item.key'>
                          <el-option :label="item.CORPNM" :value="item.IDSEQ" style="width:100%"></el-option>
                      </span>
                  </el-select>
              </div>
              <el-button type="primary"  style=" margin-top:20px;width:380px;margin-left:10px;height:40px;" icon="ios-mail-outline" @click="btnMsg">
                  <i class="iconfont icon-denglu" style="font-size:16px;margin-right:8px"></i>
                  <span style="font-size:14px;"> <i class="web-font">{{form.loginName}}</i></span>
              </el-button>
          </TabPane> -->

        </Tabs>
      </div>
      <!-- <div style="text-align:center;position:fixed;bottom:100px;margin:10px 180px" 2d8cf0>
          <qrcode :url="mpUrl" :iconurl="iconUrl" colorDark="#3498db" colorLight="#A3D1D1"  :wid="160" :hei="160" :imgwid="50" :imghei="50"></qrcode>
      </div> -->
      <div style=" line-height:35px;width:500px;text-align:center; color:#696969; background:#Fff;font-size:12px;font-weight:600">{{footer}} </div>
    </div>
    <el-dialog v-dialogDrag :show-close="false" :visible.sync="showModel" width="420px" append-to-body :close-on-press-escape="false" :close-on-click-modal="false">
      <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
        <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">{{dialog_title}}</span>
      </div>

      <div style="line-height:30px;display:flex">
        <div style="width:40px; "><i class="iconfont icon-tishi1" style="color:#5cadff;font-size:36px"></i></div>
        <div style="font-size:12px;line-height:30px; ">{{comment}}</div>
      </div>
      <div slot="footer" style="height:35px;">
        <Button type="primary"   @click="showModel=false">{{dialog_sure}}</Button>
      </div>
    </el-dialog >

  </div>
</template>
<script>
    import { clearSupplierIdentity, fetchSessionRole, persistSupplierIdentity } from '@/components/SupplierWorkbench/DashboardMain.vue'
 
    export default {
        name: "Login",
        beforeDestroy() { this.loginCanceled = true; this.roleLoginEpoch++ },
        data(){
            return {
                loginCanceled:false,
                roleLoginEpoch:0,
                v_roleid:'',
                dialog_title:'',
                dbWin:false,
                showModel:false,
                v_lang:'CN',
                iconUrl:'assets/authorize/logo.png',
                comment:'',
                active:'',
                corpnm:'',
                dbArr:[],
                dialog_sure:'',
                footer:'',
                disabled:false,/*布尔值，通过v-show控制显示 获取按钮 还是 倒计时  */
                auth_time: 0, /*倒计时 计数器*/
                loading:false,

                codeImg:'',
                foothide:false,
                filter:true,
                remchk:false,
                msgcode:{
                    phoneno:'',
                    area:'',
                    validmsg:'',
                    read:'N',
                },
                dbArr2:[],
                v_usernm:'',
                v_obj:{},
                form:{
                    username:"",
                    password:"",
                    validate:'',
                    title:'',
                    seltip:'请选择',//请选择
                    telno:'请输入手机号',//请输入手机号
                    teltip:'输入6位手机短信校验码',//输入6位手机短信校验码
                    code:'获取校验码',//获取校验码
                    loginName: '',//登录
                    loginName2: '',//
                    register: '',//注册
                    validtip:'',//请输入验证码
                    forget_pwd:'', //找回密码
                    corpid:'',
                    corpid2:'',
                    tabnm1: '' , //账户密码登录
                    tabnm2:'短信验证登录',//短信验证码登录
                    usertip:'',//请输入用户名
                    pwdtip:'', //请输入密码
                    remember:'记住我',  //记住我
                    read:'N',
                    account:'',
                }
            }
        },
        computed: {
          validateCompute:{
              get(){
                  return this.form.validate
              },
              set(val){
                  this.form.validate =val.toUpperCase()
              }
          }
        },
        components: {
          //  qrcode,
        },
        mounted() {
            this.v_usernm =this.$cookies.get('v_usernm')
            this.clickImg();
            this.form.username =this.$cookies.get('v_telno')

            if  (this.$cookies.get('v_remember')==='Y' ){
                this.form.password =this.$cookies.get('v_pwd')
                this.remchk =true
            }
            this.msgcode.area ='0086' //中国(+86)
            //账套赋予上一次
            this.active=this.$cookies.get('v_corpid')
            this.form.password=this.$cookies.get('v_password')
            this.form.corpid2=this.$cookies.get('v_corpnm')
            this.corpnm=this.$cookies.get('v_corpnm')
            this.readField()
            this.dbSelect()
        },
        created () {

        },
        methods:{

            elchange(val){  // 这个val 就是 el-select 的 value
                let obj ={}
                //console.log(val,'select')
                obj =this.dbArr.find(item=>{
                    return item['IDSEQ']===val
                })
                if (obj) {
                    //console.log(obj['CORPNM'])
                    this.active=val
                    this.corpnm=obj['CORPNM']
                }
            },
            elchange2(val){  // 这个val 就是 el-select 的 value
                let obj ={}
                obj =this.dbArr2.find(item=>{
                    return item['IDSEQ']===val
                })
                if (obj) {
                    this.active=val
                    this.corpnm=obj['CORPNM']
                }
            },
            //账户登录选择账套
            async dbSelect(){
                const  res =await this.$axios.post('xuper_api/getBaseData', {
                    p_key:'userno',p_value:this.form.username,p_key2:'stfg',p_value2:'Y',p_table:'V_SYS_DBDTL'
                })
                if (res.code!=='200'){
                    this.showModel=true
                    this.comment=res.result
                    return
                }
                this.dbArr =res.result
                if(res.result.length===0){
                    this.form.corpid=''
                }else{
                    this.form.corpid=this.$cookies.get('v_corpnm')
                }
            },

            async readField(){
                const res =await this.$axios.post('xuper_api/getBaseData', {
                     p_key:'lstseq',p_value:'1',p_key2:'idseq',p_value2:'471781',p_table:'V_SYS_form_fld'
                })
                if (res.code!=='200'){
                    this.showModel=true
                    this.comment=res.result
                    return
                }

                res.result.forEach(item=>{
                    this.v_obj[item['key']] ={'CN':item['FLDNM'],'EN':item['FLDEN'],'YN':item['FLDYN']}
                })
                //
                this.radioChg(this.v_lang)
            },

            imgRoute(){
                let routeUrl = this.$router.resolve({
                    path: '/',
                    query: { param:'main'},
                });
                window.open(routeUrl.href, '_self');
            },

            //短信登录
            btnMsg() {

            },
            //获取验证码
            getAuthCode() {

            },
            //语言设置
            radioChg(LANG){

                this.footer= this.v_obj['018'][LANG]
                this.dialog_sure= this.v_obj['017'][LANG]
                this.dialog_title= this.v_obj['016'][LANG]
                this.form.loginName2= this.v_obj['015'][LANG]
                this.form.loginName= this.v_obj['014'][LANG]
                this.form.account= this.v_obj['013'][LANG]
                this.form.usertip= this.v_obj['011'][LANG]
                this.form.pwdtip= this.v_obj['012'][LANG]
                this.form.title= this.v_obj['010'][LANG]
                this.form.forget_pwd= this.v_obj['009'][LANG]
                this.form.register= this.v_obj['008'][LANG]
                this.form.validtip = this.v_obj['007'][LANG]
                this.form.tabnm1 = this.v_obj['006'][LANG]
            },
            //注册账套
            userRegister(){
                let routeUrl = this.$router.resolve({
                    path: '/user_register',
                    query: {lang:this.LANG },
                });
                window.open(routeUrl.href, '_self');
            },
            //加入账套
            userJoin(){
                let routeUrl = this.$router.resolve({
                    path: '/user_join',
                    query: {lang:this.LANG },
                });
                window.open(routeUrl.href, '_blank');
            },
            //找回密码
            findPassword(){
                //this.$router.push({path:'/get_forget'});  //push 会在history留下记录，replace不会
                let routeUrl = this.$router.resolve({
                    path: '/get_forget',
                    query: {},
                })
                window.open(routeUrl.href, '_blank');
            },

            //点击图片重新生成
            async clickImg(){
                var vm =this
                let url_ = 'xuper_api/getValidateImg?t='+Math.random();
                this.$axios({
                    method: 'get',
                    url:url_ ,
                    responseType: 'arraybuffer',
                }).then(res=>{

                    //把二进制流转化为 base64 就不需要调用二次接口，解决获取的验证字符和生成图片不是同一接口问题
                    return 'data:image/jpeg;base64,' + btoa(
                        new Uint8Array(res.data)
                            .reduce((data, byte) => data + String.fromCharCode(byte), '')
                        );
                }).then(data => {
                    this.codeImg = data;
                }).catch(ex => {
                    console.error(ex);
                });
            } ,
            //登录
            async normalLogin(){
              if (this.loading) return
              if (!this.form.username){
                  this.showModel=true
                  this.comment= this.v_obj['001'][this.v_lang]
              }else if (!this.form.password){
                  this.showModel=true
                  this.comment=this.v_obj['002'][this.v_lang]
              }else if (!this.form.corpid){
                  this.showModel=true
                  this.comment=this.v_obj['003'][this.v_lang]
              }else if (!this.form.validate){
                  this.showModel=true
                  this.comment=this.v_obj['004'][this.v_lang]
              } else {
                    const that=this
                    that.loading=true
                    const loginEpoch=++that.roleLoginEpoch
                    //登录验证
                    return this.$axios({
                        method:'post',
                        url: 'xuper_api/loginValid' ,
                        data:{  //get这里应为params //请求参数
                            password :this.form.password,
                            username :this.form.username,
                            p_key:this.form.validate,
                            corpid:this.active
                        },
                    }).then(res =>{
                        // console.log(this.form.username,this.active)
                        if (res.code === '200'){
                                setTimeout(async()=>{
                                if (that.loginCanceled || loginEpoch !== that.roleLoginEpoch) return
                                that.$cookies.set('v_telno',res.userno); //用户账号
                                that.$cookies.set('v_usernm',res.usernm); //用户名称
                                that.$cookies.set('v_corpnm',this.corpnm); //公司名称
                                that.$cookies.set('v_corpid',this.active); //公司Id
                                that.$cookies.set('v_sys',res.sys); //系统标识s
                                that.$cookies.set('v_idseq',res.idseq); //用户序号
                                that.$cookies.set('v_admin',res.admin); //主管理账号
                                let storage=null
                                try { storage=window.localStorage } catch (_) { /* Cookies can still carry the resolved role. */ }
                                clearSupplierIdentity({cookies:that.$cookies,storage})
                                that.v_roleid=''
                                try {
                                    const roleId=await fetchSessionRole({axios:that.$axios,username:res.userno})
                                    if (that.loginCanceled || loginEpoch !== that.roleLoginEpoch) return
                                    if (String(that.$cookies.get('v_telno')) !== String(res.userno) || String(that.$cookies.get('v_corpid')) !== String(this.active)) return
                                    that.v_roleid=roleId
                                    persistSupplierIdentity({cookies:that.$cookies,storage,roleId})
                                    this.$store.commit('setLocal',this.v_lang)
                                    try {
                                        if (storage) {
                                            storage.setItem('lastActiveTime',Date.now())
                                            storage.setItem('v_corpid',this.active)
                                            storage.setItem('v_usernm',res.usernm)
                                            storage.setItem('v_idseq',res.idseq)
                                        }
                                    } catch (_) { /* Browser storage must not block a successful role lookup. */ }
                                    that.$router.push('/dashboard/main')
                                    that.$emit('child-login',res.usernm)
                                } catch (error) {
                                    if (!that.loginCanceled && loginEpoch === that.roleLoginEpoch) {
                                        that.showModel=true
                                        that.comment=that.$LANG('', '登录成功，但读取用户角色失败，请重试')+'：'+error.message
                                    }
                                } finally {
                                    if (!that.loginCanceled && loginEpoch === that.roleLoginEpoch) that.loading=false
                                }
                                },1000)
                        }else{
                            this.showModel=true
                            this.comment=res.result
                            that.loading=false
                        }
                    }).catch(error=>{
                        if (that.loginCanceled || loginEpoch !== that.roleLoginEpoch) return
                        that.loading=false
                        that.showModel=true
                        that.comment=error.message || that.$LANG('', '登录失败，请重试')
                    })
                }
            },
        }
    }
</script>
<style>
.el-checkbox__input.is-disabled.is-checked .el-checkbox__inner::after{
  border-color :#3d77eb;
}
.el-checkbox__input.is-disabled+span.el-checkbox__label{
  color:#3d77eb
}
.el-dialog__body{
  padding: 10px;
}
.el-dialog__header{
  padding: 0px;
}
.el-dialog__footer{
  padding: 5px;
  border-top:1px solid #ccc;
}
.el-dialog__headerbtn{font-size: 20px; background:white;top:5px !important;}
</style>
<style scoped lang="less">
.login-wrap {
  background-size:  cover; /* 这会让背景图片覆盖整个元素，同时保持图片的宽高比 */
  background-position: center; /* 这会让背景图片在元素中居中显示 */
  background-repeat: no-repeat; /* 防止图片重复 */
  width: 100%;
  background-image:url(/assets/basedict/bkimg.jpg) ;
  height: 100%;
  //background-size: 83% 100%;
  top:0;
  left:0;
  padding:0px;
}
.ms-title {
  width: 100%;
  line-height: 50px;
  height: 50px;
  font-size: 1.8em;
  font-weight: 700;
  color: #2b85e4;
  margin-top:15px;
}
.rowstyle {
  width: 500px;
  height:465px;
  border-radius: 5px;
  background: rgba(255, 255, 255, 0.2);
  text-align:center;

  // width: 500px;
  // height:475px;
  // border:1px solid #ccc;
  // position:absolute;


}
.left{
  float:left
}
.right{
  float:right;
  margin-right:5px;
}

.ms-content {
  padding: 10px 30px;
}
.login-btn {
  height: 42px;
  display: flex;
  justify-content: space-around;
  margin-top:20px;
}
.login-btn button {

  height: 36px;
  margin-bottom: 3px;
}

.logo {
  width: auto;
  height: 50px;
  margin-bottom:10px;
}
.remember {
  width: 100%;
  line-height: 20px;
  float:left;
  font-size: 8px;
  color: #2b85e4;
  font-weight: 500;
}
.divcolor{
  background-color: #5cadff;
}
.oneMenu:hover{
  cursor: pointer;
  background:#abcef1;
}
.active {
  background:#f1d2f1;
  text-decoration:none;
}
</style>
